import { fn } from '@ember/helper';

import BoardImagePreviewComponent from 'webapp/components/board/image-preview';
import OptionsButtonComponent from 'webapp/components/options-button';
import SubmitButtonComponent from 'webapp/components/submit-button';
import TemplatesTransferedNotificationPublicTableRowComponent from 'webapp/components/templates/transfered-notification/public/table-row';
import UsedSourcesListComponent from 'webapp/components/used-sources-list';

export default class TemplatesTransferedNotificationPublicReportTableRowComponent extends TemplatesTransferedNotificationPublicTableRowComponent {
	<template>
		<tr class={{this.classNames}}>
			<td class="cc no-grow first"></td>
			<td class="c0 board no-grow">
				<BoardImagePreviewComponent @image={{this.templateModel.image}} />

			</td>
			<td class="c1">
				<strong>{{this.templateModel.title}}</strong>
			</td>

			<td class="c2 prio-low" data-label="Data sources: ">
				{{#if this.templateModel}}
					<UsedSourcesListComponent
						@sources={{this.templateModel.sourcesUsedList}}
						@maxShownSourcesCount={{3}}
					/>
				{{/if}}
			</td>

			<td class="c3 prio-medium status">
				<SubmitButtonComponent
					@onTrigger={{fn this.handleTransferedObject true}}
					@text="Connect"
					@theme="green"
				/>
			</td>

			<td class="c4 prio-low"></td>

			<td class="c6 button-ct last">
				<OptionsButtonComponent @options={{this.options}} @onAction={{this.doAction}} />
			</td>
		</tr>
	</template>
}
